import { render } from "./ai-dependency-grid-view.vue?vue&type=template&id=46f1d2ae"
import script from "./ai-dependency-grid-view.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-dependency-grid-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/demo/ai-dependency-component/ai-dependency-grid-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46f1d2ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46f1d2ae', __exports__)) {
    api.reload('46f1d2ae', __exports__)
  }
  
  module.hot.accept("./ai-dependency-grid-view.vue?vue&type=template&id=46f1d2ae", () => {
    api.rerender('46f1d2ae', render)
  })

}


export default __exports__